module.exports = __webpack_public_path__ + "static/presys_joysticks-b04de9dc7894397b2b0ba5bd1b227136.mp4";